import { placeTree } from "./places";
export function placesForGrants(grants, companies, premises, nendaCompanyId) {
    var _a, _b, _c, _d, _e;
    const companyById = new Map(companies.map((c) => [c.id, c]));
    const premiseById = new Map(premises.map((p) => [p.id, p]));
    const parentOf = (id) => {
        var _a, _b;
        const parent = (_b = (_a = companyById.get(id)) === null || _a === void 0 ? void 0 : _a.parentId) !== null && _b !== void 0 ? _b : null;
        if (parent)
            return parent;
        return id === nendaCompanyId ? null : nendaCompanyId;
    };
    const childCompanies = new Map();
    for (const c of companies) {
        if (c.id === nendaCompanyId)
            continue;
        const parent = parentOf(c.id);
        if (parent)
            childCompanies.set(parent, [...((_a = childCompanies.get(parent)) !== null && _a !== void 0 ? _a : []), c.id]);
    }
    const premisesOf = new Map();
    for (const p of premises) {
        const company = (_b = p.companyId) !== null && _b !== void 0 ? _b : nendaCompanyId;
        premisesOf.set(company, [...((_c = premisesOf.get(company)) !== null && _c !== void 0 ? _c : []), p.id]);
    }
    const coveredCompanies = new Set();
    const coveredPremises = new Set();
    const coverCompany = (id) => {
        var _a, _b;
        if (coveredCompanies.has(id) || !companyById.has(id))
            return;
        coveredCompanies.add(id);
        for (const p of (_a = premisesOf.get(id)) !== null && _a !== void 0 ? _a : [])
            coveredPremises.add(p);
        for (const c of (_b = childCompanies.get(id)) !== null && _b !== void 0 ? _b : [])
            coverCompany(c);
    };
    for (const { place } of grants) {
        if (place.kind === "company")
            coverCompany(place.id);
        else if (premiseById.has(place.id))
            coveredPremises.add(place.id);
    }
    const aboveCompanies = new Set();
    const addAbove = (id) => {
        while (id && !coveredCompanies.has(id) && !aboveCompanies.has(id)) {
            if (!companyById.has(id))
                return;
            aboveCompanies.add(id);
            id = parentOf(id);
        }
    };
    for (const id of coveredPremises) {
        addAbove((_d = premiseById.get(id).companyId) !== null && _d !== void 0 ? _d : nendaCompanyId);
    }
    for (const id of coveredCompanies)
        addAbove(parentOf(id));
    const out = [];
    for (const c of companies) {
        const covered = coveredCompanies.has(c.id);
        if (!covered && !aboveCompanies.has(c.id))
            continue;
        out.push({
            kind: "company",
            id: c.id,
            name: c.name,
            parentId: c.id === nendaCompanyId ? null : parentOf(c.id),
            covered,
        });
    }
    for (const p of premises) {
        if (!coveredPremises.has(p.id))
            continue;
        out.push({
            kind: "premise",
            id: p.id,
            slug: p.slug,
            name: p.name,
            parentId: (_e = p.companyId) !== null && _e !== void 0 ? _e : nendaCompanyId,
            covered: true,
        });
    }
    return out;
}
export function browserAccess(snapshot) {
    const parents = new Map();
    const bySlug = new Map();
    for (const p of snapshot.places) {
        parents.set(`${p.kind}:${p.id}`, p.parentId);
        if (p.kind === "premise" && p.slug) {
            bySlug.set(p.slug, { kind: "premise", id: p.id });
        }
    }
    const tree = placeTree({
        nendaCompanyId: snapshot.nendaCompanyId,
        premiseOfUnit: () => undefined,
        companyOfPremise: (id) => parents.get(`premise:${id}`),
        parentOfCompany: (id) => parents.get(`company:${id}`),
    });
    return {
        user: { kind: snapshot.kind, grants: snapshot.grants },
        tree,
        nenda: { kind: "company", id: snapshot.nendaCompanyId },
        premiseBySlug: (slug) => { var _a; return (_a = bySlug.get(slug)) !== null && _a !== void 0 ? _a : null; },
        covered: snapshot.places
            .filter((p) => p.covered)
            .map((p) => ({ kind: p.kind, id: p.id })),
    };
}
